import { type FormFieldInfo, type FormRequiredMode, type OnChange, type OnLoading, type Submit } from "@common/controls/Form/component";
import { identityPromise } from "@common/lib/misc";
import { identity } from "lodash";
import React from "react";

export type ContextFormFieldInfo<T> = FormFieldInfo<T> & {};

export interface FormContextOptions {
  requiredMode: FormRequiredMode;
  toast?: string;
}
export interface FormContextProps<T> {
  hasChanges: boolean;
  onChange: OnChange<T>;
  onLoading: OnLoading<T>;
  options: FormContextOptions;
  patch: (name: string, info: Partial<FormFieldInfo<T>>) => void;
  register: (name: string) => void;
  submit: Submit;
  unregister: (name: string) => void;
  validate: () => Promise<boolean> | boolean;
  validateOnChange?: boolean;

  fields: ContextFormFieldInfo<T>[];
}

export const FormContext = React.createContext<FormContextProps<any>>({
  hasChanges: false,
  fields: [],
  onChange: identity,
  onLoading: identity,
  options: {
    requiredMode: "default"
  },
  patch: identity,
  register: identity,
  submit: identityPromise,
  unregister: identity,
  validate: () => Promise.resolve(true)
});
